<template>
  <div id="app">
       <Menu/>

<!-- <div style="margin: 3rem;">  <btn id="connectBtn" v-on:click="connect()">Connect Wallet</btn></div> -->

  <b-container>
                  <h1 class="w ko">UNSTAKE YOUR GLMJ</h1>
            <div class="zoom py-3"><btn id="connectBtn" class="zoom" v-on:click="connect()">Connect Wallet</btn></div>
            <p v-if="!isConnect" class="w">Click only once and wait...</p>
      <div id="explain">
    <b-col>
    <div class="py-3">
  </div>

        <br>
            <p class="h3 pt-3 px w" v-if="jpts.nStaked > 0"><strong> GLMJ Staked:</strong></p><p v-if="jpts.nStaked > 0" v-bind="jpts" class="g h3">{{ jpts.nStaked }}</p>
            <b-button type="button" class="text-center ml-auto mt-4 px" variant="outline-light" size="lg" v-if="!jpts.isApproved" v-on:click="rApprove()">💚 <strong>Approve JUNGLE POINTS first</strong></b-button>

           <b-button type="button" class="text-center px" variant="outline-light" size="lg" v-if="jpts.nStaked > 0" v-on:click="aUnstake()" style="margin-top: 1rem;">🥇 Unstake all your GLMJ !</b-button>

</b-col>
        </div>

        <b-row cols="3" class="">

          <b-col class="mx-auto mx-2 py-4" fluid v-for="(item, index) in images" :key="index" transition="staggered" stagger="250">
          <p class="h4 y py-2 font-weight-bold px"><span class="glmr">GLMR</span><span class="catchy"> JUNGLE</span> <span class="px font-weight-bold w">#{{images[index].id}}</span></p>
          <b-img-lazy class="ape" v-bind:src="images[index].url"></b-img-lazy>
           <div class="inline pt-3">
          </div>
          </b-col>
        </b-row>

                <b-modal v-bind="tokendetail" id="modal" title="" @shown="checkTraits">
            
            <div class="text-center">
            <p class="my-2 h4"><strong class="h4 g">GLMR JUNGLE<br> #{{ tokendetail.id }}</strong></p>
            <b-img-lazy id="imgdetail" class="ape" v-bind:src="tokendetail.image2"></b-img-lazy>
              <p class="pt-3 h4"><strong class="py-2">Attributes:</strong></p>
           <b-list-group class="mx-auto" v-for="(item, index2) in tokendetail.attributes" :key="index2">
             <b-list-group-item class="h5 l bg-transparent px"><span class="o">{{tokendetail.attributes[index2].trait_type}}</span><br><span class="trait2">{{tokendetail.attributes[index2].value}}</span></b-list-group-item>
            </b-list-group>
          <p class="my-3"><strong class="py-2 h4">Find it on:</strong><br>
          <a class="h5" target="_blank" :href="'https://tofunft.com/nft/moonbeam/0xcB13945Ca8104f813992e4315F8fFeFE64ac49cA/' + tokendetail.id"> tofuNFT</a><br>
          <a class="h5" target="_blank" :href="'https://raregems.io/moonbeam/0xcB13945Ca8104f813992e4315F8fFeFE64ac49cA/' + tokendetail.id"> rareGems</a><br>
          <a class="h5" target="_blank" :href="'https://nftrade.com/assets/moonbeam/0xcb13945ca8104f813992e4315f8ffefe64ac49ca/' + tokendetail.id"> NFTrade</a>
          </p>
           
            </div>
   
            </b-modal>

                <b-modal v-bind="tokendetail" id="modaltransfer" title="🐒 Transfer">
            
            <div class="text-center">
            <b-img-lazy id="imgdetail" class="ape" v-bind:src="tokendetail.image2"></b-img-lazy>
            <p class="my-4 h4"><strong class="h4 g">GLMR JUNGLE<br> #{{ tokendetail.id }}</strong></p>
            <p class="my-4 px"><strong class="cy">Recipient's address:</strong></p>
            <b-input-group size="lg">
            <b-form-input class="px-4 catchy" id="toWallet"></b-form-input>
            </b-input-group>
        <b-button type="button" class="cta my-4 mx-2 h3 px" variant="success mx-2" size="lg" v-if="isConnect" v-on:click="transfer(tokendetail.id)"><strong class="i">Transfer</strong></b-button><br>
            </div>
   
            </b-modal>


    </b-container>
  <b-row>
            <Footer/>
                      </b-row>
  </div>
</template>

<script>
import Menu from './Menu.vue'
import Footer from './Footer.vue'
import { ethers } from 'ethers'
import { db } from '../main.js'
import { glmjAddress, glmjABI, bananasAddress, bananasABI, jptsAddress, jptsABI} from './conf.js'

export default {
  name: 'Staking',
  components: {
    Menu,
    Footer,
  },
  data() {
 return {
images: [],
isConnect: false,
tokendetail: {},
ids: [], 
gorilla: [],
chimpanzee: [],
orangutan: [],
bonobo: [],
jpts: {
        totalSupply: 0,
        sRewards: 0,
        nStaked: 0,
        isApproved: 0,
        tokenStaked: [],
      },
    };
  },
  mounted() {

  },
  methods: {


     async rData(a) {

   let singleApe = {}
   new Promise(() => {
            fetch(`https://www.glmrjungle.com/nfts/${a}.json`)
            .then(res => res.json())
            .then(res => {
                singleApe = {
                    name: res.name,
                    image: res.image,
                    image2: `https://www.glmrjungle.com/nfts/art/${res.edition}.png`,
                    id: res.edition,
                    attributes: res.attributes,
                }
          this.tokendetail = singleApe;
    })
    

   });
  async function raritycheck(a) {
console.log(a)
  }
  await raritycheck(singleApe)
     },

         async rApprove() {
   let provider = new ethers.providers.Web3Provider(window.ethereum)
   let signer = provider.getSigner();
  let contract = new ethers.Contract(glmjAddress, glmjABI, signer);
   const approve = await contract.setApprovalForAll(jptsAddress, true);
    await approve.wait()
    alert(`JUNGLE POINTS successfully approved !`)
    window.location.reload();
    },

                    rTransfer(a) {

   let singleApe = {}
   new Promise(() => {
            fetch(`https://www.glmrjungle.com/nfts/${a}.json`)
            .then(res => res.json())
            .then(res => {
                singleApe = {
                    name: res.name,
                    image: res.image,
                    image2: `https://www.glmrjungle.com/nfts/art/${res.edition}.png`,
                    id: res.edition,
                    attributes: res.attributes,
                }
          this.tokendetail = singleApe;
    })
   });
     },

    async addMM() {
const tokenAddress = '0x00e4C3DfB33c3a90090C305679D1Ac805f461783';
const tokenSymbol = 'JPTS';
const tokenDecimals = 18;
//const tokenImage = 'http://placekitten.com/200/300';

try {
  // wasAdded is a boolean. Like any RPC method, an error may be thrown.
  const wasAdded = await window.ethereum.request({
    method: 'wallet_watchAsset',
    params: {
      type: 'ERC20', // Initially only supports ERC20, but eventually more!
      options: {
        address: tokenAddress, // The address that the token is at.
        symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
        decimals: tokenDecimals, // The number of decimals in the token
        //image: tokenImage, // A string url of the token logo
      },
    },
  });

  if (wasAdded) {
    console.log('JPTS added to MM');
  } else {
    console.log('Your loss!');
  }
} catch (error) {
  console.log(error);
}
    },


           async transfer(b) {
var toWallet = document.getElementById('toWallet').value;   
var tokenTransfer = b;

      let provider = new ethers.providers.Web3Provider(window.ethereum)
      let signer = provider.getSigner();
      let connectedWallet = await signer.getAddress();
      let contract = new ethers.Contract(glmjAddress, glmjABI, signer);
      let blockNumber = await provider.getBlockNumber()
      let gasPrice = await provider.getGasPrice()
      let overrides = {
        gasPrice: gasPrice
        }
      let w = await signer.getAddress();


    const transfer = await contract["safeTransferFrom(address,address,uint256)"](connectedWallet, toWallet, tokenTransfer);
  await transfer.wait()
    alert(`Succesfully transfer GLMR JUNGLE  #${tokenTransfer} to ${toWallet} !`)
    window.location.reload();
   },



          async checkS(d) {
            let gHolder = []    
            let cHolder = []  
            let oHolder = []
            let bHolder = []

let g = [8,9,11,12,13,22,23,27,33,36,38,40,43,45,54,55,56,57,59,60,65,66,69,71,72,74,75,77,78,79,81,83,87,89,90,92,94,96,97,101,106,107,108,109,110,120,122,123,128,130,131,133,137,138,140,141,142,144,145,147,149,150,152,153,154,155,156,159,162,164,165,168,171,173,178,180,181,183,185,187,188,190,191,194,195,200,201,202,203,204,205,207,209,214,220,223,224,225,228,230,231,234,235,238,239,240,241,244,247,248,252,255,256,261,265,268,269,275,278,279,283,284,288,289,290,295,296,299,301,304,305,307,308,310,311,320,326,327,328,329,333,335,336,337,340,341,345,352,353,354,355,361,363,366,367,368,372,376,377,378,379,381,384,386,387,388,389,390,391,396,398,399,400,404,406,410,412,413,415,420,427,430,432,436,437,438,439,440,441,444,447,449,450,451,453,454,456,458,465,470,471,472,473,475,476,477,478,480,481,484,485,487,490,493,496,497,498,500,501,506,508,509,510,512,518,521,522,526,531,533,539,541,544,545,546,547,549,550,551,553,558,561,563,564,566,567,569,570,574,576,577,578,586,589,591,595,596,599,600,605,609,616,617,620,621,623,625,626,629,630,633,636,639,642,643,644,645,647,650,651,652,656,657,659,664,665,666,667,668,669,670,671,677,681,685,686,687,689,691,699,701,707,710,713,714,715,717,719,723,724,727,728,729,734,736,737,738,739,740,741,744,745,747,748,750,751,752,753,754,757,760,761,762,765,766,769,773,774,776,777,778,780,781,784,785,786,788,789,791,792,794,797,798,801,802,803,806,807,808,809,812,813,818,819,820,823,827,828,829,830,835,836,839,840,842,847,848,851,852,855,857,859,860,863,865,868,872,875,877,878,880,882,884,885,886,887,888,889,890,891,893,895,896,898,900,903,907,908,909,910,914,916,917,919,923,927,928,930,932,938,939,940,942,947,949,950,952,957,958,959,961,962,963,967,968,970,971,973,974,977,980,984,985,988,991,996,997,998,999,1000,1001,1002,1006,1007,1009,1010,1012,1014,1015,1018,1022,1023,1031,1034,1036,1037,1043,1044,1046,1049,1051,1054,1056,1059,1060,1061,1062,1063,1067,1068,1069,1072,1073,1075,1078,1081,1082,1088,1091,1092,1094,1095,1098,1103,1105,1108,1113,1114,1115,1116,1118,1120,1122,1123,1126,1127,1129,1130,1133,1135,1138,1141,1142,1144,1145,1146,1149,1151,1152,1153,1154,1160,1161,1162,1163,1165,1171,1173,1176,1177,1178,1179,1180,1181,1189,1190,1192,1194,1195,1198,1199,1202,1205,1207,1209,1211,1215,1217,1219,1220,1221,1222,1226,1229,1232,1233,1235,1236,1237,1238,1239,1243,1245,1246,1247,1250,1255,1256,1257,1261,1263,1268,1272,1278,1284,1286,1288,1290,1291,1293,1294,1295,1297,1298,1300,1303,1304,1307,1311,1312,1313,1315,1316,1319,1322,1326,1328,1329,1332,1334,1335,1337,1338,1340,1341,1342,1343,1346,1348,1351,1353,1356,1357,1358,1359,1360,1361,1362,1363,1364,1366,1367,1371,1372,1373,1377,1378,1380,1383,1384,1387,1388,1392,1393,1394,1395,1396,1398,1399,1401,1402,1404,1405,1406,1409,1410,1413,1414,1416,1420,1422,1424,1426,1427,1429,1432,1434,1438,1439,1440,1444,1446,1447,1448,1450,1453,1457,1459,1466,1467,1469,1472,1473,1478,1480,1481,1485,1487,1489,1492,1496,1497,1499,1500,1503,1505,1508,1510,1511,1515,1516,1518,1519,1520,1521,1524,1526,1531,1532,1537,1540,1541,1542,1543,1544,1552,1553,1554,1555,1556,1557,1558,1561,1564,1565,1568,1569,1570,1573,1577,1578,1582,1583,1585,1595,1597,1598,1599,1600,1605,1607,1608,1609,1610,1613,1614,1615,1620,1627,1630,1632,1639,1640,1643,1644,1645,1647,1649,1650,1653,1654,1656,1661,1663,1664,1666,1667,1673,1674,1675,1678,1679,1681,1682,1683,1685,1693,1697,1702,1703,1708,1710,1712,1714,1717,1718,1720,1728,1729,1737,1738,1739,1741,1742,1745,1746,1747,1752,1753,1757,1758,1761,1762,1765,1776,1777,1781,1782,1783,1787,1788,1789,1792,1793,1794,1795,1797,1799,1800,1801,1802,1804,1807,1808,1811,1813,1814,1815,1819,1823,1831,1833,1835,1839,1840,1842,1843,1844,1848,1850,1851,1853,1854,1857,1859,1862,1864,1865,1867,1868,1870,1871,1872,1879,1880,1882,1885,1887,1888,1890,1893,1894,1895,1901,1905,1907,1914,1915,1916,1918,1919,1920,1923,1926,1927,1933,1936,1938,1940,1941,1947,1948,1949,1950,1952,1953,1954,1955,1956,1958,1959,1960,1963,1964,1965,1966,1968,1969,1971,1976,1978,1979,1980,1981,1983,1985,1986,1988,1989,1990,1993,1994,1995,1997,1998,1999,2000,2001,2005,2006,2007,2008,2009,2011,2012,2017,2021,2022,2026,2027,2028,2030,2032,2033,2034,2036,2037,2039,2040,2044,2047,2050,2052,2054,2058,2059,2062,2063,2065,2066,2069,2070,2073,2075,2076,2077,2081,2082,2083,2084,2089,2092,2093,2094,2096,2097,2098,2099,2100,2104,2105,2106,2109,2110,2111,2113,2114,2116,2117,2123,2126,2127,2130,2133,2136,2137,2143,2146,2147,2150,2152,2153,2158,2159,2160,2162,2163,2165,2168,2169,2170,2174,2175,2176,2177,2186,2190,2191,2192,2195,2197,2198,2200,2203,2204,2207,2209,2210,2211,2217,2218,2219,2220,2221,2224,2226,2227,2232,2237,2240,2241,2243,2250,2252,2254,2257,2260,2261,2266,2271,2274,2275,2277,2280,2284,2285,2286,2287,2294,2296,2300,2302,2306,2307,2308,2309,2312,2313,2315,2317,2320,2321,2322,2323,2325,2328,2329,2331,2332,2336,2338,2348,2352,2354,2357,2358,2360,2361,2365,2371,2373,2374,2375,2376,2377,2381,2384,2385,2386,2387,2393,2396,2399,2402,2403,2404,2407,2408,2409,2410,2411,2417,2422,2427,2429,2431,2433,2435,2436,2437,2438,2439,2443,2444,2448,2449,2450,2451,2460,2461,2471,2474,2476,2478,2479,2483,2484,2487,2489,2495,2496,2500,2501,2503,2505,2508,2513,2514,2516,2520,2521,2523,2524,2525,2527,2530,2531,2532,2533,2535,2536,2537,2539,2545,2547,2549,2551,2552,2554,2557,2559,2563,2567,2569,2570,2571,2572,2573,2578,2579,2584,2585,2588,2590,2592,2598,2601,2603,2606,2609,2610,2611,2612,2613,2615,2616,2618,2619,2621,2623,2631,2634,2635,2636,2638,2644,2649,2654,2661,2662,2663,2667,2668,2670,2671,2673,2674,2675,2676,2677,2678,2679,2680,2685,2687,2690,2693,2695,2696,2698,2701,2704,2705,2707,2709,2712,2715,2722,2723,2724,2726,2727,2728,2731,2733,2734,2735,2736,2737,2738,2739,2740,2741,2742,2743,2746,2748,2750,2752,2754,2759,2760,2762,2763,2765,2767,2769,2770,2773,2774,2776,2778,2779,2780,2781,2782,2783,2784,2788,2790,2793,2804,2805,2806,2807,2808,2814,2815,2821,2824,2825,2827,2828,2829,2831,2837,2840,2842,2845,2850,2851,2852,2856,2860,2863,2864,2865,2866,2870,2871,2872,2873,2875,2877,2879,2881,2882,2884,2886,2889,2891,2892,2895,2899,2903,2904,2905,2908,2913,2914,2916,2917,2919,2923,2926,2930,2933,2934,2936,2937,2938,2942,2944,2945,2946,2947,2949,2951,2954,2955,2956,2960,2963,2969,2970,2973,2980,2981,2982,2983,2986,2989,2991,2993,2994,2995,2998,3003,3004,3007,3011,3015,3017,3018,3019,3024,3025,3026,3028,3034,3038,3039,3043,3046,3047,3049,3050,3051,3052,3053,3057,3059,3060,3061,3062,3063,3065,3068,3069,3073,3077,3078,3079,3082,3084,3085,3093,3094,3095,3096,3098,3101,3102,3103,3104,3106,3107,3108,3111,3113,3116,3117,3118,3120,3121,3122,3124,3125,3128,3129,3132,3135,3137,3139,3140,3142,3146,3147,3151,3153,3158,3163,3164,3166,3167,3169,3172,3173,3176,3177,3179,3183,3186,3188,3189,3190,3192,3194,3196,3197,3199,3201,3204,3205,3208,3209,3210,3211,3212,3214,3215,3217,3220,3221,3223,3224,3226,3229,3230,3232,3234,3235,3236,3238,3241,3242,3244,3245,3247,3250,3252,3255,3256,3257,3267,3269,3270,3273,3281,3286,3288,3292,3294,3297,3301,3302,3303,3304,3309,3310,3313,3316,3320,3322,3323,3325,3328,3329,3331,3332]
let c = [5,6,7,10,14,16,17,19,20,25,26,28,29,30,32,34,37,39,42,44,46,47,53,61,62,63,67,70,76,80,84,86,88,91,95,98,100,102,103,104,105,111,112,113,114,115,117,118,119,121,124,126,127,132,134,139,143,146,151,157,160,163,166,167,169,170,174,175,177,182,184,186,189,193,197,206,208,212,213,215,217,218,219,221,222,226,227,229,232,233,236,242,245,246,250,258,259,260,264,266,271,272,274,276,277,280,281,282,285,286,287,291,292,294,302,306,309,312,313,315,316,317,319,321,322,323,324,325,330,339,342,343,344,346,347,348,349,350,351,356,357,358,360,362,364,371,373,375,380,382,383,392,394,395,397,402,403,405,407,408,411,417,418,421,423,426,429,431,433,434,435,442,443,445,446,448,452,455,457,459,460,461,462,463,467,468,469,479,482,483,488,491,492,499,507,511,513,514,516,519,523,524,525,528,535,536,537,542,543,552,556,557,560,562,568,573,575,579,580,582,584,585,593,594,598,603,606,607,608,612,613,618,619,622,624,627,628,631,632,634,635,641,648,653,654,655,658,660,661,662,663,672,673,676,678,679,683,688,690,694,695,696,697,698,700,704,706,709,712,720,721,722,725,730,731,732,733,735,742,746,749,756,759,763,764,767,768,771,772,775,779,783,793,799,805,810,814,815,816,822,824,825,826,831,832,843,846,850,853,854,861,864,866,869,870,871,873,874,876,881,883,892,894,897,899,901,905,912,913,915,918,920,921,922,924,925,926,929,931,934,936,937,944,945,946,948,951,953,954,955,956,965,966,969,976,979,981,982,987,989,990,992,993,994,1003,1004,1005,1013,1017,1019,1020,1024,1026,1028,1035,1038,1039,1040,1041,1042,1045,1047,1050,1057,1058,1065,1066,1070,1071,1074,1076,1077,1079,1080,1083,1084,1086,1087,1089,1093,1096,1099,1101,1102,1106,1107,1110,1111,1112,1119,1124,1125,1132,1136,1137,1143,1147,1148,1158,1164,1166,1167,1168,1172,1174,1175,1183,1185,1186,1188,1191,1193,1200,1201,1203,1204,1206,1208,1210,1212,1213,1216,1218,1224,1228,1230,1231,1234,1241,1242,1244,1248,1249,1252,1253,1254,1258,1259,1260,1262,1265,1267,1269,1270,1271,1274,1275,1276,1277,1279,1280,1281,1282,1283,1285,1287,1299,1301,1302,1305,1306,1308,1309,1310,1318,1321,1323,1324,1330,1331,1333,1336,1339,1344,1345,1352,1354,1368,1369,1370,1374,1375,1376,1381,1385,1386,1390,1391,1397,1400,1407,1408,1417,1418,1421,1423,1425,1430,1431,1433,1435,1437,1441,1442,1443,1445,1449,1451,1452,1454,1455,1458,1460,1461,1462,1463,1465,1468,1470,1471,1474,1477,1482,1483,1484,1486,1488,1490,1491,1494,1495,1498,1501,1504,1506,1507,1509,1512,1513,1517,1522,1525,1527,1528,1530,1534,1535,1536,1546,1547,1548,1549,1550,1551,1559,1562,1563,1566,1567,1572,1575,1576,1580,1581,1587,1588,1589,1591,1592,1593,1596,1601,1602,1603,1604,1606,1611,1612,1617,1618,1619,1621,1622,1624,1625,1626,1629,1631,1633,1635,1636,1637,1638,1641,1642,1648,1651,1652,1658,1660,1662,1665,1669,1670,1671,1672,1677,1680,1684,1686,1687,1688,1689,1691,1694,1696,1698,1699,1700,1704,1705,1707,1709,1711,1713,1721,1722,1723,1724,1725,1726,1727,1730,1731,1734,1736,1740,1743,1744,1749,1754,1755,1760,1764,1766,1767,1768,1769,1770,1772,1773,1774,1775,1778,1779,1784,1785,1786,1790,1791,1796,1798,1803,1805,1806,1812,1817,1818,1820,1822,1824,1825,1826,1827,1828,1830,1832,1836,1841,1847,1849,1852,1855,1856,1858,1863,1866,1869,1873,1874,1875,1878,1884,1886,1889,1891,1892,1897,1899,1900,1902,1903,1904,1906,1911,1913,1917,1921,1924,1928,1929,1934,1935,1937,1939,1942,1944,1945,1946,1951,1957,1961,1962,1967,1970,1974,1975,1977,1982,1987,1992,1996,2002,2010,2015,2016,2019,2024,2025,2029,2031,2038,2042,2045,2051,2053,2055,2056,2057,2060,2061,2064,2071,2074,2078,2080,2085,2086,2087,2088,2090,2095,2101,2102,2103,2107,2115,2118,2119,2120,2121,2122,2128,2129,2131,2134,2139,2141,2144,2145,2148,2149,2154,2155,2156,2157,2164,2167,2171,2172,2173,2178,2180,2182,2183,2184,2188,2193,2194,2201,2205,2208,2213,2214,2215,2216,2222,2223,2225,2228,2230,2231,2234,2236,2238,2239,2242,2244,2246,2247,2253,2255,2258,2259,2262,2263,2265,2268,2269,2272,2273,2278,2279,2281,2282,2289,2290,2291,2292,2293,2295,2297,2298,2299,2301,2303,2304,2310,2314,2316,2324,2327,2330,2333,2337,2339,2340,2341,2342,2344,2345,2346,2349,2350,2351,2353,2356,2359,2362,2364,2366,2367,2368,2370,2372,2378,2379,2382,2388,2389,2390,2392,2397,2398,2401,2414,2415,2416,2418,2419,2421,2423,2424,2425,2426,2428,2430,2432,2434,2440,2441,2442,2447,2452,2453,2457,2462,2463,2464,2465,2467,2470,2472,2475,2477,2480,2482,2485,2488,2490,2491,2492,2493,2497,2498,2499,2504,2506,2509,2510,2511,2512,2515,2517,2518,2519,2522,2526,2529,2540,2541,2542,2544,2546,2548,2550,2553,2555,2558,2560,2561,2564,2565,2568,2575,2577,2580,2581,2583,2587,2589,2593,2595,2597,2600,2604,2607,2614,2617,2620,2622,2624,2625,2626,2628,2630,2632,2633,2637,2639,2640,2642,2645,2646,2650,2651,2652,2653,2655,2656,2657,2658,2659,2660,2664,2665,2666,2669,2672,2683,2686,2688,2689,2691,2692,2694,2697,2700,2702,2703,2706,2710,2711,2713,2714,2717,2718,2720,2721,2725,2730,2732,2744,2745,2747,2751,2753,2755,2756,2768,2771,2775,2785,2786,2787,2789,2791,2794,2795,2796,2797,2799,2800,2801,2802,2803,2811,2812,2813,2818,2819,2822,2823,2830,2832,2834,2835,2836,2838,2839,2843,2844,2846,2847,2848,2849,2853,2854,2855,2857,2858,2859,2861,2862,2867,2868,2874,2876,2878,2880,2883,2888,2893,2894,2896,2897,2900,2901,2902,2906,2907,2909,2910,2911,2912,2915,2918,2922,2924,2925,2927,2929,2931,2932,2935,2948,2950,2953,2961,2962,2964,2966,2968,2972,2974,2975,2978,2987,2988,2992,2997,3000,3001,3002,3006,3014,3021,3027,3030,3031,3032,3033,3035,3036,3040,3041,3044,3054,3055,3056,3058,3064,3066,3067,3070,3075,3076,3080,3081,3083,3086,3087,3088,3089,3090,3091,3097,3099,3100,3105,3110,3114,3115,3126,3127,3130,3134,3136,3138,3141,3143,3145,3149,3150,3152,3156,3157,3159,3160,3162,3165,3170,3178,3184,3185,3187,3191,3193,3195,3198,3200,3206,3207,3216,3218,3222,3225,3228,3231,3233,3237,3248,3249,3251,3253,3258,3259,3261,3262,3263,3264,3265,3271,3272,3274,3275,3276,3277,3278,3280,3282,3284,3285,3287,3289,3291,3295,3296,3298,3300,3305,3306,3308,3311,3314,3315,3317,3318,3319,3321,3324,3326,3327,3330,3333]
let o = [4,15,18,21,24,31,41,48,49,50,51,52,58,64,68,82,85,93,116,125,129,135,148,158,161,176,179,196,199,216,237,243,251,254,262,267,270,273,297,298,300,303,314,318,331,332,334,359,365,369,370,374,385,393,401,414,416,419,422,424,425,428,464,489,494,495,502,503,504,505,515,517,520,527,529,530,532,534,538,548,554,555,559,565,571,581,583,587,588,590,597,601,602,604,610,611,614,637,638,646,649,674,675,680,682,684,692,693,702,703,705,708,711,716,718,726,743,758,770,782,787,790,796,800,804,811,817,821,833,837,838,841,844,845,849,856,858,862,867,879,902,906,911,935,941,943,960,972,975,978,983,986,995,1008,1011,1016,1021,1025,1027,1029,1030,1032,1055,1064,1085,1090,1097,1100,1104,1117,1121,1131,1134,1150,1155,1156,1157,1159,1169,1170,1182,1184,1187,1197,1214,1223,1225,1240,1251,1264,1273,1289,1292,1296,1314,1317,1320,1325,1327,1347,1350,1355,1365,1379,1382,1389,1411,1415,1419,1428,1456,1464,1475,1476,1479,1493,1502,1514,1523,1529,1533,1538,1539,1545,1571,1574,1579,1584,1586,1590,1594,1623,1628,1634,1646,1657,1659,1668,1676,1690,1692,1695,1701,1706,1715,1719,1732,1733,1735,1748,1751,1756,1759,1763,1809,1821,1829,1834,1837,1845,1846,1860,1861,1876,1877,1881,1883,1896,1898,1908,1909,1910,1912,1922,1925,1930,1931,1972,1984,1991,2003,2014,2018,2020,2023,2041,2043,2046,2048,2049,2067,2068,2072,2091,2108,2112,2124,2125,2132,2135,2138,2140,2142,2151,2161,2166,2179,2181,2185,2199,2202,2206,2212,2229,2235,2245,2248,2249,2251,2256,2264,2267,2270,2283,2288,2305,2311,2318,2319,2326,2334,2343,2347,2355,2363,2369,2380,2383,2391,2395,2400,2406,2412,2420,2445,2446,2454,2455,2456,2458,2459,2466,2468,2469,2473,2481,2486,2494,2507,2538,2543,2556,2566,2574,2576,2582,2591,2594,2596,2605,2608,2627,2629,2643,2647,2682,2684,2699,2716,2719,2729,2749,2757,2761,2764,2766,2772,2777,2792,2798,2809,2816,2817,2820,2826,2833,2841,2890,2898,2920,2921,2928,2939,2940,2941,2943,2952,2957,2958,2967,2971,2976,2977,2979,2984,2985,2990,2996,2999,3005,3009,3012,3016,3020,3022,3023,3029,3037,3042,3048,3071,3072,3074,3092,3109,3112,3123,3133,3144,3148,3154,3155,3161,3171,3174,3180,3181,3182,3202,3203,3213,3219,3227,3239,3240,3243,3254,3260,3266,3268,3279,3283,3290,3293,3299,3307]
let b = [1,2,3,35,73,99,136,172,192,198,210,211,249,253,257,263,293,338,409,466,474,486,540,572,592,615,640,755,795,834,904,933,964,1033,1048,1052,1053,1109,1128,1139,1140,1196,1227,1266,1349,1403,1412,1436,1560,1616,1655,1716,1750,1771,1780,1810,1816,1838,1932,1943,1973,2004,2013,2035,2079,2187,2189,2196,2233,2276,2335,2394,2405,2413,2502,2528,2534,2562,2586,2599,2602,2641,2648,2681,2708,2758,2810,2869,2885,2887,2959,2965,3008,3010,3013,3045,3119,3131,3168,3175,3246,3312]
 
    d.forEach(element => {
            if (g.includes(element)) {
        gHolder.push(element);
      }
      if (c.includes(element)) {
        cHolder.push(element);
      }

      if (o.includes(element)) {
        oHolder.push(element);
      }
        if (b.includes(element)) {
        bHolder.push(element);
      }
        }
        );

this.gorilla = gHolder
console.log(this.gorilla)
this.chimpanzee = cHolder
this.orangutan = oHolder
this.bonobo = bHolder
let score = [gHolder.length, cHolder.length, oHolder.length, bHolder.length]
return score
    },


        async connect() {

       const provider = new ethers.providers.Web3Provider(window.ethereum)
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner()
      const signerAddress = await signer.getAddress()
      const bananasContract = new ethers.Contract(bananasAddress, bananasABI, signer);
      const glmjContract = new ethers.Contract(glmjAddress, glmjABI, signer);
      let supply = await glmjContract.totalSupply()
      supply = supply.toNumber();
      let owned = await glmjContract.walletOfOwner(signerAddress)
      let owned3 = owned.length
   let tokens = await glmjContract.balanceOf(signerAddress)
     // this.tokensOwned = tokens;

    if (tokens > 0) {
    let tokensArray = []
    for (let i = 0; i < tokens.toNumber(); i++) {
      let index = await glmjContract.tokenOfOwnerByIndex(signerAddress, i)
      tokensArray.push(index.toNumber())
    }
      this.ids = tokensArray;
    }
      await alert(`${signerAddress} connected`)

       let explain2 = window.document.getElementById('explain')
        let connect2 = window.document.getElementById('connectBtn')
        //let owned2 = window.document.getElementById('tokensOwned')
      let result2 = []
      if (owned.length > 0) {
          owned.forEach(element => {
        result2.push(parseFloat(element))
        }
        );
       let galleryLinks = []
      if (result2.length > 0) {
     
     for (let g = 0; g < result2.length; g++) {
      galleryLinks.push({id:`${result2[g]}`, url:`https://www.glmrjungle.com/nfts/art/${result2[g]}.png`})
     }
     this.images = galleryLinks;
      }

        let result = await this.checkS(result2)


      }


      explain2.style.display = "flex";
      connect2.style.display = "none";

    const stakingContract = new ethers.Contract(jptsAddress, jptsABI, signer);
    let rewards = await stakingContract.getAllRewards(signerAddress)
    let totalSupply = await stakingContract.totalSupply()
    let nStaked = await stakingContract.getTokensStaked(signerAddress)

function convert(arr) {
    let result = [];
    let el;
    for (el of arr) {
        result.push(el.toNumber())
    }
    return result.sort(function(a, b) {
  return a - b;
});
}




this.jpts.totalSupply = totalSupply / 1000000000000000000
this.jpts.sRewards = rewards / 1000000000000000000
this.jpts.nStaked = nStaked.length;
this.jpts.tokenStaked = convert(nStaked);
let approvedJpts = await glmjContract.isApprovedForAll(signerAddress, jptsAddress);
if (approvedJpts == true) {
  this.jpts.isApproved = 1;
}
      this.isConnect = true;
    },

      async deposit(a) {
        console.log('sent', a)
      this.isLoading = true;
      let provider = new ethers.providers.Web3Provider(window.ethereum)
      let signer = provider.getSigner();
      const stakingContract = new ethers.Contract(jptsAddress, jptsABI, signer);
      let blockNumber = await provider.getBlockNumber()
      let gasPrice = await provider.getGasPrice()
      let overrides = {
        gasPrice: gasPrice,
        gasLimit: 200000
        }
      const transfer = await stakingContract.stakeByIds([a]);
      await transfer.wait()
      alert(`GLMR JUNGLE #${a} successfully staked!`)
      window.location.reload();
        },

              async depositG() {
      this.isLoading = true;
      let provider = new ethers.providers.Web3Provider(window.ethereum)
      let signer = provider.getSigner();
      const stakingContract = new ethers.Contract(jptsAddress, jptsABI, signer);
      let blockNumber = await provider.getBlockNumber()
      let gasPrice = await provider.getGasPrice()
      let overrides = {
        gasPrice: gasPrice,
        gasLimit: 200000
        }
      const transfer = await stakingContract.stakeByIds(this.gorilla);
      await transfer.wait()
      alert(`Your Gorillas have been successfully staked`)
      window.location.reload();
        },
                      async depositC() {
      this.isLoading = true;
      let provider = new ethers.providers.Web3Provider(window.ethereum)
      let signer = provider.getSigner();
      const stakingContract = new ethers.Contract(jptsAddress, jptsABI, signer);
      let blockNumber = await provider.getBlockNumber()
      let gasPrice = await provider.getGasPrice()
      let overrides = {
        gasPrice: gasPrice,
        gasLimit: 200000
        }
      const transfer = await stakingContract.stakeByIds(this.chimpanzee);
      await transfer.wait()
      alert(`Your Chimpanzees have been successfully staked`)
      window.location.reload();
        },
                      async depositO() {
      this.isLoading = true;
      let provider = new ethers.providers.Web3Provider(window.ethereum)
      let signer = provider.getSigner();
      const stakingContract = new ethers.Contract(jptsAddress, jptsABI, signer);
      let blockNumber = await provider.getBlockNumber()
      let gasPrice = await provider.getGasPrice()
      let overrides = {
        gasPrice: gasPrice,
        gasLimit: 200000
        }
      const transfer = await stakingContract.stakeByIds(this.orangutan);
      await transfer.wait()
      alert(`Your Orangutans have been successfully staked`)
      window.location.reload();
        },
                      async depositB() {
      this.isLoading = true;
      let provider = new ethers.providers.Web3Provider(window.ethereum)
      let signer = provider.getSigner();
      const stakingContract = new ethers.Contract(jptsAddress, jptsABI, signer);
      let blockNumber = await provider.getBlockNumber()
      let gasPrice = await provider.getGasPrice()
      let overrides = {
        gasPrice: gasPrice,
        gasLimit: 200000
        }
      const transfer = await stakingContract.stakeByIds(this.bonobo);
      await transfer.wait()
      alert(`Your Bonobos have been successfully staked`)
      window.location.reload();
        },

            async rClaim() {
     this.isLoading = true;
      let provider = new ethers.providers.Web3Provider(window.ethereum)
      let signer = provider.getSigner();
     const stakingContract = new ethers.Contract(jptsAddress, jptsABI, signer);
      let blockNumber = await provider.getBlockNumber()
      let gasPrice = await provider.getGasPrice()
      let overrides = {
        gasPrice: gasPrice
        }
      let w = await signer.getAddress();
    const collect = await stakingContract.claimAll();
    await collect.wait()
    alert(`JUNGLE POINTS claimed successfully!`)
    window.location.reload();
    },

      async Unstake(a) {
      this.isLoading = true;
      let provider = new ethers.providers.Web3Provider(window.ethereum)
      let signer = provider.getSigner();
     const stakingContract = new ethers.Contract(jptsAddress, jptsABI, signer);
    const unstake = await stakingContract.unstakeByIds([a]);
    await unstake.wait()
    alert(`GLMR JUNGLE ${a} successfully unstaked !`)
    window.location.reload();
    },

        async aUnstake() {
      this.isLoading = true;
      let provider = new ethers.providers.Web3Provider(window.ethereum)
      let signer = provider.getSigner();
    const stakingContract = new ethers.Contract(jptsAddress, jptsABI, signer);
    const unstake = await stakingContract.unstakeAll();
    await unstake.wait()
    alert(`Successfully unstaked all your GLMR JUNGLE and sent your JUNGLE POINTS.`)
    window.location.reload();
    },

            async aStake() {
      let tokensNotStaked = this.ids;
      this.isLoading = true;
      let provider = new ethers.providers.Web3Provider(window.ethereum)
      let signer = provider.getSigner();
   const stakingContract = new ethers.Contract(jptsAddress, jptsABI, signer);
      let blockNumber = await provider.getBlockNumber()
      let gasPrice = await provider.getGasPrice()
      let overrides = {
        gasPrice: gasPrice,
        gastLimit: 1500000000
        }

    const transfer = await stakingContract.stakeByIds(tokensNotStaked);
    await transfer.wait()
    alert(`All your GLMJ (${tokensNotStaked}) have been staked successfully !`)
    window.location.reload();
    },


   
  }
}
</script>

<style>
@import './style.css';
@import url('https://fonts.googleapis.com/css2?family=Bree+Serif&family=Staatliches&display=swap');
</style>